import { Checkbox, svgIconClasses, Switch, switchClasses, Typography, menuItemClasses, typographyClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { typography } from "../../themes/typography/typography.js";
import { Avatar } from "../avatar/avatar.js";
import { Icon } from "../icons/MainIcon/MainIcon.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "react/jsx-runtime";
import "@mui/material/Avatar/index.js";
import "../avatar/avatar.styles.js";
import "../../themes/shadows/shadows.js";
const menuItemStyles = ({ size }) => ({
  [`&.${menuItemClasses.root}`]: {
    ...typography["Lato Body 1"],
    backgroundColor: "grey.0",
    borderColor: "grey.400",
    color: "grey.800",
    justifyContent: "space-between",
    width: "100%"
  },
  [`&:hover:not(.${menuItemClasses.selected}, .${menuItemClasses.focusVisible})`]: {
    backgroundColor: "primary.50",
    // aqua → primary
    "& span": {
      color: "grey.800"
    }
  },
  [`&.${menuItemClasses.selected}, &.${menuItemClasses.focusVisible}, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: {
    backgroundColor: "primary.75",
    // aqua → primary
    "& span": {
      color: "grey.800"
    },
    [`& p.${typographyClasses.root}`]: {
      color: "grey.900"
    }
  },
  [`&.${menuItemClasses.selected}:hover, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}:hover, &.${menuItemClasses.focusVisible}:hover`]: {
    backgroundColor: "primary.100"
    // aqua → primary
  },
  // Size variations remain unchanged
  ...size === "l" && {
    height: "56px",
    padding: "12px 18px"
  },
  ...size === "m" && {
    height: "48px",
    padding: "8px 18px"
  },
  ...size === "s" && {
    height: "40px",
    padding: "4px 18px"
  },
  ...size === "xs" && {
    ...typography["Lato Body 2"],
    height: "32px",
    padding: "2px 18px"
  }
});
const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  [`& .${svgIconClasses.root}`]: {
    color: theme.palette.primary[800]
  },
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.primary[800]
  }
}));
const StyledSwitch = styled(Switch)(({ theme }) => ({
  [`& .${switchClasses.switchBase}.${switchClasses.disabled}.${switchClasses.checked}+.${switchClasses.track}`]: {
    backgroundColor: theme.palette.primary[800]
  },
  [`& .${switchClasses.switchBase}.${switchClasses.disabled}+.${switchClasses.track}`]: {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.grey[600]
  }
}));
const StyledCheckmarkIcon = styled(Icon)(({ theme }) => ({
  [`&.${svgIconClasses.root}`]: {
    color: theme.palette.primary[800]
  }
}));
const ContentWrapper = styled("span")(() => ({
  display: "flex",
  alignItems: "center"
}));
const StyledAvatar = styled(Avatar)(() => ({
  marginRight: "8px"
}));
const StyledIcon = styled(Icon)(({ theme }) => ({
  marginRight: "8px",
  color: theme.palette.grey[800]
}));
const StyledSubtitle = styled(Typography)(
  ({ theme }) => ({
    marginRight: "8px",
    color: theme.palette.grey[700]
  })
);
export {
  ContentWrapper,
  StyledAvatar,
  StyledCheckbox,
  StyledCheckmarkIcon,
  StyledIcon,
  StyledSubtitle,
  StyledSwitch,
  menuItemStyles
};
